import React from 'react';
import { Link } from 'react-router';
import { Button, Typography, Box } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export default function UnauthorisedPage() {
  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      minHeight='80vh'
      textAlign='center'
      gap={2}
      p={3}
    >
      <WarningAmberIcon color='warning' sx={{ fontSize: 80 }} />
      <Typography variant='h3' color='textPrimary'>
        Access Denied
      </Typography>
      <Typography variant='body1' color='textSecondary'>
        You do not have permission to view this page.
      </Typography>
      <Button
        variant='outlined'
        sx={{ borderColor: '#357a38', color: '#357a38' }}
        component={Link}
        to='/'
      >
        Go Back Home
      </Button>
    </Box>
  );
}
